import { R } from "../../../uni-questionnaire/R";

export type ColorMeaning = 'Default' | 'Primary' | 'Success' | 'Warning' | 'Danger' | 'Info';

export function GetDialogColorByMeaning(meaning: ColorMeaning | undefined) {
  if (meaning === 'Danger') {
    return 'error.main';
  } else if (meaning === 'Success') {
    return 'success.main';
  } else if (meaning === 'Primary') {
    return R.color.primary;
  } else if (meaning === 'Warning') {
    return 'warning.main';
  } else if (meaning === 'Info') {
    return 'info.main';
  } else if (meaning === 'Default') {
    return undefined;
  } else {
    return undefined;
  }
}

export function GetDialogButtonColorByMeaning(meaning: ColorMeaning | undefined) {
  if (meaning === 'Danger') {
    return 'error';
  } else if (meaning === 'Success') {
    return 'success';
  } else if (meaning === 'Primary') {
    return 'primary';
  } else if (meaning === 'Warning') {
    return 'warning';
  } else if (meaning === 'Info') {
    return 'info';
  } else if (meaning === 'Default') {
    return 'inherit';
  } else {
    return undefined;
  }
}